import Autocomplete from "@material-ui/lab/Autocomplete";
import { AutocompleteValidator } from "utils/Validators/CommonValidator";
import React from "react";
import TextField from "@material-ui/core/TextField";
import { Validate } from "utils/Validators/Validate";
import conf from "config/env.conf.js";
import getDefaultValue from "utils/DefaultValue";
/* custom components */
import useFetch from "hooks/useFetch";

const ListboxVotcardColorAll = props => {
  const [, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState("");
  const [valid, setValid] = React.useState();
  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + `/voteCard/voteCardColorAll`,
    []
  );

  let content = (
    <TextField disabled label="เลือกสีบัตรทั้งหมด" margin="normal" fullWidth />
  );

  let data = [];

  if (!isLoading && fetchData !== null && fetchData.data !== undefined) {
    data = fetchData.data.map(v => {
      return { id: v.colorId, value: v.colorName };
    });
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        disabled={props.disabled}
        id="listBoxVotecardColorall"
        options={data}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={AutocompleteValidator(
          props.onChange,
          props.validators,
          setError,
          setHelperText
        )}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label="เลือกสีบัตรทั้งหมด"
              margin="normal"
              error={valid}
              fullWidth
              helperText={helperText}
              onChange={Validate(
                params.inputProps.value,
                props.required,
                setValid
              )}
              required={props.required}
            />
          );
        }}
        {...props.customProps}
      />
    );
  }
  return content;
};
export default ListboxVotcardColorAll;
